import React from 'react';
import {
	Breadcrumb,
	Card,
	Row,
	Col,
	Button,
	message,
	Spin,
	Alert,
	Statistic,
	Table,
	Tag,
	Divider,
	Typography,
	Progress,
	Modal,
	Result,
} from 'antd';
import {
	WarningOutlined,
	ReloadOutlined,
	CarOutlined,
	InfoCircleOutlined,
	SyncOutlined,
	CheckCircleOutlined,
	CloseCircleOutlined,
	LoadingOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	setConfig,
} from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import Cookies from 'js-cookie';

const configClass = {
	title: 'Tunggakan Kendaraan',
	apiUrl: {
		tunggakan:       'analitik/api/tunggakan/',
		sinkron:         'analitik/api/tunggakan/sinkron/',
		sinkronProgress: 'analitik/api/tunggakan/sinkron/progress/',
	},
	breadCrumb: [
		<span><CarOutlined /> Analitik</span>,
		'Tunggakan Kendaraan',
	],
};

const config = new Config();

const formatJumlah = (val) => {
	if (!val && val !== 0) return '-';
	return Math.round(val).toLocaleString('id-ID');
};

const AGING_KEYS = ['belum_jatuh_tempo', 'lewat_jatuh_tempo', '1_tahun', '2_tahun', '3_plus_tahun'];
const AGING_LABELS = {
	belum_jatuh_tempo: 'Belum Jatuh Tempo',
	lewat_jatuh_tempo: 'Lewat Jatuh Tempo',
	'1_tahun':         'Tunggakan 1 Tahun',
	'2_tahun':         'Tunggakan 2 Tahun',
	'3_plus_tahun':    'Tunggakan 3+ Tahun',
};
const AGING_COLORS = {
	belum_jatuh_tempo: '#52c41a',
	lewat_jatuh_tempo: '#faad14',
	'1_tahun':         '#fa8c16',
	'2_tahun':         '#f5222d',
	'3_plus_tahun':    '#820014',
};

const agingJumlah  = (agingData) => (agingData || {}).jumlah || 0;
const agingKet     = (key, agingData) => {
	if (!agingData) return null;
	if (key === 'belum_jatuh_tempo' && agingData.rata_hari_tersisa != null)
		return `Rata-rata ${agingData.rata_hari_tersisa} hari lagi jatuh tempo`;
	if (agingData.rata_hari_terlambat != null)
		return `Rata-rata terlambat ${agingData.rata_hari_terlambat} hari (${agingData.rata_bulan_terlambat} bln)`;
	return null;
};

const WARNA_CONFIG = {
	PUTIH:   { color: '#262626', background: '#f5f5f5', border: '#d9d9d9', label: 'Plat Putih (Pribadi)' },
	MERAH:   { color: '#fff',    background: '#f5222d', border: '#f5222d', label: 'Plat Merah (Dinas)'   },
	KUNING:  { color: '#262626', background: '#faad14', border: '#faad14', label: 'Plat Kuning (Umum)'   },
	LAINNYA: { color: '#fff',    background: '#8c8c8c', border: '#8c8c8c', label: 'Lainnya'              },
};

const PlatTag = ({ warna }) => {
	const cfg = WARNA_CONFIG[warna] || WARNA_CONFIG.LAINNYA;
	return (
		<Tag style={{ color: cfg.color, background: cfg.background, borderColor: cfg.border, fontWeight: 700, fontSize: 13, padding: '2px 10px' }}>
			{cfg.label || warna}
		</Tag>
	);
};

// ─── Step description dengan ikon ────────────────────────────────────────────
const STEP_ICON = {
	processing: <LoadingOutlined style={{ color: '#1890ff' }} />,
	done:       <CheckCircleOutlined style={{ color: '#52c41a' }} />,
	error:      <CloseCircleOutlined style={{ color: '#f5222d' }} />,
};

class TunggakanKendaraan extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading:       false,
			data:          null,
			// progress sinkronisasi
			sinkronModal:  false,
			sinkronStatus: 'idle',   // idle | processing | done | error | already_running
			sinkronTaskId: null,
			sinkronPersen: 0,
			sinkronStep:   '',
			sinkronDetail: '',
			sinkronHasil:  null,     // {dibuat, diupdate, dihapus, total}
		};
		this._pollInterval = null;
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentWillUnmount() {
		this._stopPolling();
	}

	// ── Polling ─────────────────────────────────────────────────────────────

	_startPolling(taskId) {
		this._stopPolling();
		this._pollInterval = setInterval(() => this._cekProgress(taskId), 2000);
	}

	_stopPolling() {
		if (this._pollInterval) {
			clearInterval(this._pollInterval);
			this._pollInterval = null;
		}
	}

	_cekProgress(taskId) {
		const token   = Cookies.get(config.get_cookie_name());
		const baseUrl = config.get_base_url().replace(/\/$/, '');
		const url     = `${baseUrl}/${configClass.apiUrl.sinkronProgress}?task_id=${taskId}`;

		fetch(url, { headers: { Authorization: token } })
			.then((res) => res.json())
			.then((res) => {
				if (res.status === 'not_found') return;

				this.setState({
					sinkronPersen: res.persen || 0,
					sinkronStep:   res.step   || '',
					sinkronDetail: res.detail || '',
				});

				if (res.status === 'done') {
					this._stopPolling();
					this.setState({
						sinkronStatus: 'done',
						sinkronHasil:  {
							dibuat:   res.dibuat   || 0,
							diupdate: res.diupdate || 0,
							dihapus:  res.dihapus  || 0,
							total:    res.total    || 0,
						},
					});
				} else if (res.status === 'error') {
					this._stopPolling();
					this.setState({ sinkronStatus: 'error' });
				}
			})
			.catch(() => {
				// Abaikan network error saat polling — coba lagi di interval berikutnya
			});
	}

	// ── Mulai sinkronisasi ───────────────────────────────────────────────────

	jalankanSinkron() {
		const token   = Cookies.get(config.get_cookie_name());
		const baseUrl = config.get_base_url().replace(/\/$/, '');
		const url     = `${baseUrl}/${configClass.apiUrl.sinkron}`;

		this.setState({
			sinkronModal:  true,
			sinkronStatus: 'processing',
			sinkronTaskId: null,
			sinkronPersen: 0,
			sinkronStep:   'Menghubungi server...',
			sinkronDetail: '',
			sinkronHasil:  null,
		});

		fetch(url, { method: 'POST', headers: { Authorization: token } })
			.then((res) => res.json())
			.then((res) => {
				if (res.status === 'already_running') {
					const taskId = res.task_id;
					this.setState({ sinkronTaskId: taskId, sinkronStatus: 'already_running' });
					// Tetap mulai polling agar tampilan ikut terupdate
					this._startPolling(taskId);
					return;
				}
				if (res.status === 'processing' && res.task_id) {
					const taskId = res.task_id;
					this.setState({ sinkronTaskId: taskId });
					this._startPolling(taskId);
					return;
				}
				// Error dari server
				this.setState({
					sinkronStatus: 'error',
					sinkronStep:   'Gagal memulai sinkronisasi',
					sinkronDetail: res.detail || '',
				});
			})
			.catch((err) => {
				this.setState({
					sinkronStatus: 'error',
					sinkronStep:   'Gagal menghubungi server',
					sinkronDetail: err.message || '',
				});
			});
	}

	tutupModal() {
		this._stopPolling();
		const { sinkronStatus } = this.state;
		this.setState({ sinkronModal: false });
		// Reload data setelah sinkronisasi selesai
		if (sinkronStatus === 'done') {
			this.fetchData(true);
		}
	}

	// ── Fetch data tampilan ──────────────────────────────────────────────────

	fetchData(forceRefresh = false) {
		const token   = Cookies.get(config.get_cookie_name());
		const baseUrl = config.get_base_url().replace(/\/$/, '');
		const url     = `${baseUrl}/${configClass.apiUrl.tunggakan}${forceRefresh ? '?force_refresh=true' : ''}`;

		this.setState({ loading: true, data: null });

		fetch(url, { headers: { Authorization: token } })
			.then((res) => {
				if (!res.ok) return res.text().then((t) => { throw new Error(`HTTP ${res.status}: ${t.substring(0, 200)}`); });
				return res.json();
			})
			.then((data) => this.setState({ data, loading: false }))
			.catch((err) => {
				message.error('Gagal memuat data: ' + (err.message || 'kesalahan tidak diketahui'));
				this.setState({ loading: false });
			});
	}

	// ── Render progress modal ────────────────────────────────────────────────

	renderSinkronModal() {
		const { sinkronModal, sinkronStatus, sinkronPersen, sinkronStep, sinkronDetail, sinkronHasil } = this.state;

		const isProcessing = sinkronStatus === 'processing' || sinkronStatus === 'already_running';
		const isDone       = sinkronStatus === 'done';
		const isError      = sinkronStatus === 'error';

		const strokeColor = isError ? '#f5222d' : isDone ? '#52c41a' : { '0%': '#108ee9', '100%': '#87d068' };

		return (
			<Modal
				open={sinkronModal}
				title={
					<span>
						{STEP_ICON[isError ? 'error' : isDone ? 'done' : 'processing']}
						<span style={{ marginLeft: 8 }}>Sinkronisasi Database</span>
					</span>
				}
				footer={
					isProcessing ? null : (
						<Button
							type={isDone ? 'primary' : 'default'}
							onClick={() => this.tutupModal()}
						>
							{isDone ? 'Tutup & Muat Ulang Data' : 'Tutup'}
						</Button>
					)
				}
				closable={!isProcessing}
				maskClosable={false}
				onCancel={() => !isProcessing && this.tutupModal()}
				width={520}
			>
				{/* Progress bar */}
				<Progress
					percent={sinkronPersen}
					status={isError ? 'exception' : isDone ? 'success' : 'active'}
					strokeColor={strokeColor}
					style={{ marginBottom: 12 }}
				/>

				{/* Step saat ini */}
				<div style={{ marginBottom: 4, fontWeight: 600, fontSize: 14 }}>
					{sinkronStep}
				</div>
				{sinkronDetail && (
					<div style={{ color: '#666', fontSize: 13, marginBottom: 16 }}>
						{sinkronDetail}
					</div>
				)}

				{/* Pesan already_running */}
				{sinkronStatus === 'already_running' && (
					<Alert
						type="info"
						showIcon
						message="Sinkronisasi sedang berjalan"
						description="Terdapat proses sinkronisasi yang sudah dimulai sebelumnya. Menampilkan progresnya di bawah ini."
						style={{ marginBottom: 12 }}
					/>
				)}

				{/* Hasil setelah selesai */}
				{isDone && sinkronHasil && (
					<Result
						status="success"
						title="Sinkronisasi berhasil!"
						subTitle={`Total kendaraan tunggakan aktif: ${formatJumlah(sinkronHasil.total)}`}
						style={{ padding: '12px 0 0' }}
						extra={
							<Row gutter={16} justify="center">
								<Col>
									<Statistic title="Ditambahkan"  value={sinkronHasil.dibuat}   valueStyle={{ color: '#52c41a', fontSize: 20 }} />
								</Col>
								<Col>
									<Statistic title="Diperbarui"   value={sinkronHasil.diupdate} valueStyle={{ color: '#1890ff', fontSize: 20 }} />
								</Col>
								<Col>
									<Statistic title="Dihapus"      value={sinkronHasil.dihapus}  valueStyle={{ color: '#fa8c16', fontSize: 20 }} />
								</Col>
							</Row>
						}
					/>
				)}

				{/* Pesan error */}
				{isError && (
					<Alert
						type="error"
						showIcon
						message="Sinkronisasi gagal"
						description="Terjadi kesalahan saat proses sinkronisasi. Silakan coba lagi atau hubungi administrator."
					/>
				)}

				{/* Catatan saat proses berjalan */}
				{isProcessing && (
					<Alert
						type="warning"
						showIcon
						icon={<LoadingOutlined />}
						message="Proses sedang berjalan"
						description="Jangan tutup halaman ini. Sinkronisasi data berjalan di background server."
						style={{ marginTop: 12 }}
					/>
				)}
			</Modal>
		);
	}

	// ── Render ringkasan ─────────────────────────────────────────────────────

	renderSummaryCards() {
		const { data } = this.state;
		if (!data) return null;
		const { ringkasan } = data;
		const perAging = ringkasan.per_aging || {};
		const total    = ringkasan.total_kendaraan_tunggakan;

		return (
			<>
				<Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
					<Col xs={24} sm={12} md={6}>
						<Card size="small" style={{ borderColor: '#f5222d' }}>
							<Statistic
								title="Total Kendaraan Menunggak"
								value={total}
								formatter={formatJumlah}
								valueStyle={{ color: '#f5222d', fontSize: 22 }}
								prefix={<WarningOutlined />}
							/>
							<div style={{ marginTop: 4, fontSize: 11, color: '#999' }}>
								Data per {data.tanggal_hitung}
								{data.dari_cache && (
									<Tag color="blue" style={{ marginLeft: 6, fontSize: 10 }}>
										Cache · {data.dihitung_pada}
									</Tag>
								)}
							</div>
						</Card>
					</Col>
					{AGING_KEYS.map((key) => {
						const agingData = perAging[AGING_LABELS[key]] || {};
						const val       = agingData.jumlah || 0;
						const pct       = total > 0 ? (val / total * 100).toFixed(1) : 0;
						const ket       = agingKet(key, agingData);
						return (
							<Col xs={24} sm={12} md={key === 'belum_jatuh_tempo' || key === 'lewat_jatuh_tempo' ? 6 : 4} key={key}>
								<Card size="small">
									<Statistic
										title={AGING_LABELS[key]}
										value={val}
										formatter={formatJumlah}
										valueStyle={{ color: AGING_COLORS[key], fontSize: 16 }}
									/>
									<Progress percent={parseFloat(pct)} strokeColor={AGING_COLORS[key]} size="small" format={(p) => `${p}%`} style={{ marginTop: 4 }} />
									{ket && <div style={{ fontSize: 11, color: '#666', marginTop: 4 }}>{ket}</div>}
								</Card>
							</Col>
						);
					})}
				</Row>

				<Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
					{Object.entries(ringkasan.per_warna_plat || {}).map(([warna, jumlah]) => {
						const pct = total > 0 ? (jumlah / total * 100).toFixed(1) : 0;
						const cfg = WARNA_CONFIG[warna] || WARNA_CONFIG.LAINNYA;
						return (
							<Col xs={24} sm={8} key={warna}>
								<Card size="small" style={{ borderColor: cfg.border }} title={<PlatTag warna={warna} />}>
									<Statistic
										value={jumlah}
										formatter={formatJumlah}
										valueStyle={{ fontSize: 20 }}
										suffix={<span style={{ fontSize: 13, color: '#999' }}>kendaraan</span>}
									/>
									<Progress percent={parseFloat(pct)} strokeColor={cfg.background} size="small" format={(p) => `${p}% dari total`} />
								</Card>
							</Col>
						);
					})}
				</Row>

				<Alert
					type="info"
					showIcon
					icon={<InfoCircleOutlined />}
					style={{ marginBottom: 16 }}
					message="Informasi Deduplication Data"
					description={
						<span>
							Data dari <strong>DB Baru</strong>: {formatJumlah(ringkasan.dari_db_baru)} kendaraan.&nbsp;
							Data dari <strong>DB Lama</strong> (unik, tidak ada di DB baru): {formatJumlah(ringkasan.dari_db_lama_unik)} kendaraan.&nbsp;
							Data duplikat yang dihapus: <strong>{formatJumlah(ringkasan.deduplikasi_dihapus)}</strong> kendaraan
							(dicocokkan berdasarkan nomor mesin + rangka).
						</span>
					}
				/>
			</>
		);
	}

	renderTabelWarna(warna, detail) {
		const cfg = WARNA_CONFIG[warna] || WARNA_CONFIG.LAINNYA;

		const columns = [
			{
				title: 'Jenis Kendaraan',
				dataIndex: 'jenis',
				key: 'jenis',
				width: 220,
				render: (text) => <strong>{text}</strong>,
			},
			{
				title: 'Total',
				dataIndex: 'total',
				key: 'total',
				align: 'right',
				width: 100,
				render: (val) => <Tag color="default" style={{ fontWeight: 700 }}>{formatJumlah(val)}</Tag>,
			},
			...AGING_KEYS.map((key) => ({
				title: <span style={{ color: AGING_COLORS[key], fontWeight: 600 }}>{AGING_LABELS[key]}</span>,
				key,
				align: 'right',
				width: 130,
				render: (_, record) => {
					const agingData = record.aging?.[key] || {};
					const val       = agingJumlah(agingData);
					const pct       = record.total > 0 ? (val / record.total * 100).toFixed(0) : 0;
					const ket       = agingKet(key, agingData);
					return (
						<div>
							<span>{formatJumlah(val)}&nbsp;<span style={{ fontSize: 11, color: '#999' }}>({pct}%)</span></span>
							{ket && <div style={{ fontSize: 10, color: '#999', lineHeight: 1.3 }}>{ket}</div>}
						</div>
					);
				},
			})),
		];

		const agingTotal = AGING_KEYS.reduce((acc, k) => { acc[k] = (detail.aging || {})[k] || {}; return acc; }, {});

		return (
			<Card
				key={warna}
				size="small"
				style={{ marginBottom: 16, borderColor: cfg.border }}
				title={
					<span>
						<PlatTag warna={warna} />
						<span style={{ marginLeft: 8, fontWeight: 400, color: '#666' }}>
							Total: <strong>{formatJumlah(detail.total)}</strong> kendaraan menunggak
						</span>
					</span>
				}
			>
				<Table
					columns={columns}
					dataSource={(detail.per_jenis || []).map((r, i) => ({ ...r, key: i }))}
					pagination={false}
					size="small"
					bordered
					style={{ overflowX: 'auto' }}
					summary={() => (
						<Table.Summary.Row style={{ background: '#fafafa', fontWeight: 700 }}>
							<Table.Summary.Cell index={0}>TOTAL</Table.Summary.Cell>
							<Table.Summary.Cell index={1} align="right">
								<Tag color="default" style={{ fontWeight: 700 }}>{formatJumlah(detail.total)}</Tag>
							</Table.Summary.Cell>
							{AGING_KEYS.map((key, i) => (
								<Table.Summary.Cell key={key} index={i + 2} align="right">
									{formatJumlah(agingJumlah(agingTotal[key]))}
								</Table.Summary.Cell>
							))}
						</Table.Summary.Row>
					)}
				/>
			</Card>
		);
	}

	renderDetail() {
		const { data } = this.state;
		if (!data) return null;
		const warnaOrder = ['PUTIH', 'MERAH', 'KUNING', 'LAINNYA'];
		const entries    = Object.entries(data.per_warna_plat || {});
		entries.sort(([a], [b]) => {
			const ia = warnaOrder.indexOf(a);
			const ib = warnaOrder.indexOf(b);
			return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
		});
		return (
			<>
				<Divider orientation="left">Detail per Warna Plat & Jenis Kendaraan</Divider>
				{entries.map(([warna, detail]) => this.renderTabelWarna(warna, detail))}
			</>
		);
	}

	render() {
		const { loading, data, sinkronStatus } = this.state;
		const sinkronSedangJalan = sinkronStatus === 'processing' || sinkronStatus === 'already_running';

		return (
			<div>
				<Helmet>
					<title>{configClass.title} | Aplikasi</title>
				</Helmet>
				<Breadcrumb style={{ marginBottom: 16 }}>
					{configClass.breadCrumb.map((item, i) => <Breadcrumb.Item key={i}>{item}</Breadcrumb.Item>)}
				</Breadcrumb>

				<Card
					title={<span><WarningOutlined style={{ marginRight: 8, color: '#f5222d' }} />{configClass.title}</span>}
					size="small"
					style={{ marginBottom: 16 }}
					extra={
						<>
							<Button
								icon={<SyncOutlined spin={sinkronSedangJalan} />}
								loading={sinkronSedangJalan}
								onClick={() => this.jalankanSinkron()}
								style={{ marginRight: 8 }}
								type="dashed"
								disabled={loading}
							>
								Sinkronisasi DB
							</Button>
							{data && (
								<Button
									icon={<ReloadOutlined />}
									loading={loading}
									onClick={() => this.fetchData(true)}
									style={{ marginRight: 8 }}
									danger
								>
									Perbarui Data
								</Button>
							)}
							<Button
								type="primary"
								icon={<ReloadOutlined />}
								loading={loading}
								onClick={() => this.fetchData(false)}
							>
								{data ? 'Muat Ulang' : 'Muat Data'}
							</Button>
						</>
					}
				>
					<Typography.Paragraph style={{ margin: 0, color: '#666' }}>
						Rekapitulasi kendaraan yang melewati jatuh tempo pembayaran PKB (SD_NOTICE).
						Data digabung dari database lama dan baru dengan deduplication berdasarkan
						nomor mesin + rangka, dikelompokkan per warna plat dan jenis kendaraan.
					</Typography.Paragraph>
				</Card>

				{this.renderSinkronModal()}

				<Spin spinning={loading} tip="Memuat data tunggakan...">
					{!data && !loading && (
						<Card>
							<div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
								<WarningOutlined style={{ fontSize: 48, marginBottom: 16, color: '#f5222d' }} />
								<div>Klik <strong>Muat Data</strong> untuk melihat rekapitulasi tunggakan kendaraan.</div>
								<div style={{ fontSize: 12, marginTop: 8 }}>
									Proses mungkin memerlukan beberapa detik karena menggabungkan dua database.
								</div>
							</div>
						</Card>
					)}
					{data && (
						<>
							{this.renderSummaryCards()}
							{this.renderDetail()}
						</>
					)}
				</Spin>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;

export default connect(mapStateToProps, {
	initHandler,
	ajaxViewHandler,
	setConfig,
})(TunggakanKendaraan);
